

















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
//@ts-ignore
import { NotificationEventBus } from "@/EventBus";
import WeightingGroup from "@/views/Viewpoint/Weighting/ViewpointWeightingRecursiveGroup.vue";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Apps from '@/store/modules/Apps';
import Weighting from "@/store/modules/Weighting";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Colors from "@/utils/Colors";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import Sticky from 'vue-sticky-directive';
import _ from "lodash";
import Users from "@/store/modules/Users";
import Modelling from "@/store/modules/Modelling";
import AutocreateViewpointDialog from '@/components/common/AutocreateViewpointDialog.vue'
import { Viewpoint } from "@/api/model/Viewpoint";
import ViewpointCreatorButton from '@/views/Viewpoint/ViewpointCreatorButton.vue';
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';
import ViewpointVisibilitySelectorMenu from '@/components/workspace-options/ViewpointVisibilitySelectorMenu.vue'

const appsModule = getModule(Apps);
const modellingModule = getModule(Modelling)
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const weightingModule = getModule(Weighting);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const usersModule = getModule(Users);

@Component({
    components: {
        ConfirmationDialog,
        WeightingGroup,
        AutocreateViewpointDialog,
        ViewpointCreatorButton,
        ViewpointVisibilitySelectorMenu
    },
    directives: {
        Sticky,
    },
})
export default class ViewpointWeighting extends Vue {
    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;

    @Prop({ default: false, type: Boolean })
    heroActive!: boolean

    private colors = Colors.COLORS
    private readonly widthOptions: any[] = WorkspaceOptionValues.WIDTH_OPTIONS;

    private publishing = false;
    private viewpointsAsyncDotProcess: any = {};
    private showCreateViewpointDialog = false;
    private menu = false;
    
    get viewpointLock() {
        return appsModule.viewpointSelectionMenu;
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get scrollContainerWidth() {
        return this.columnWidth * this.selectedViewpoints.length + this.choiceFirstCol;
    }

    get cardContainerSize() {
        if(this.appEmbed){
            if (this.heroActive) {
                return 'height: calc(100vh - 139px);';
            } else {
                return 'height: calc(100vh - 40px);';
            }
        }else{
             return `min-height:calc(100vh - 126px);`;
        }
    }

     get mainContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if (this.appEmbed) {
            if (this.heroActive) {
                return `min-height: calc(100vh - 138px - ${commentHeight}px); 
                    max-height: calc(100vh - 138px - ${commentHeight}px);`;
            }
            else {
                return `min-height: calc(100vh - 38px - ${commentHeight}px); 
                    max-height: calc(100vh - 38px - ${commentHeight}px);`;
            }
        }else{
             return `max-height : calc(100vh - 125px - ${commentHeight}px); 
                    min-height:calc(100vh - 125px - ${commentHeight}px)`;
        }
    }

    get commentBottomHeight(){
        return workspaceOptionsModule.commentBottomHeight;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedViewpoints() {
        console.log(viewpointsModule.selectedViewpoints)
        return viewpointsModule.selectedViewpoints;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get totalDots() {
        return 1000;
    }

    get viewpointsWeightingDotsMap() {
        return weightingModule.viewpointGroupDots;
    }

    get dataReady() {
        return this.factorResources && this.selectedDecision && this.selectedViewpoints
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel
    }

    get usedDots() {
        if (this.factorResources) {
            return _.sumBy(Object.values(this.factorResources).filter(f => f.type === 'FACTOR'), 'numWeightingDots');
        }
        return this.totalDots;
    }

    get dotsRemaining() {
        return this.totalDots - this.usedDots;
    }

    get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M')
        
        } else {
            return ['M']
        }
    }

    get columnWidth() {
        return workspaceOptionsModule.choiceColumnWidth;
    }
    get choiceFirstCol() {
        return workspaceOptionsModule.choiceFirstCol;
    }

    set columnWidth(columnWidth: number) {
        workspaceOptionsModule.changeChoiceColumnWidth(columnWidth);
    }

    set choiceFirstCol(columnWidth: number) {
        workspaceOptionsModule.changeChoiceFirstCol(columnWidth)
    }

    private getTopGroup(topId: string) {
        if(this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return this.factorResources[topId].childrenIds
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    private async submitNewWeights(viewpointId: string) {

        try {
            NotificationEventBus.emitProcessingMessage();
            await weightingModule.submitWeightChanges(viewpointId)
            NotificationEventBus.emitSuccessMessage()
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e)
        }
    }

    private dotsRemainingChanged(viewpointId: string) {
        if (this.viewpointsAsyncDotProcess[viewpointId] != null) {
            clearTimeout(this.viewpointsAsyncDotProcess[viewpointId])
        }
        this.viewpointsAsyncDotProcess[viewpointId] = setTimeout(() => {
            this.syncWeightsFromDotsAndSubmit(viewpointId)
        }, 5000);

        // let weightChanges: any = {};
        // this.syncFromDots('M', weightChanges)

    }

    syncWeightsFromDotsAndSubmit(viewpointId: string) {
        this.submitNewWeights(viewpointId);
        delete this.viewpointsAsyncDotProcess[viewpointId];
    }

    private async createAutocreateViewpoint(payload: any) {
        NotificationEventBus.emitProcessingMessage();
        this.showCreateViewpointDialog = false;
        let newViewpoint = {
            viewpointId: '',
        };
        try {
            if (!this.selectedDecision) return;
            let newVp = {
                decisionId: this.selectedDecision.decisionId,
                name: payload.name,
                description: payload.description,
                addToList: true
            }
            newViewpoint =  await decisionsModule.createDecisionViewpoint(newVp);
            if(newViewpoint?.viewpointId != '' && workspaceOptionsModule.activeViewpointLists.length > 0) {
                decisionsModule.addViewpointToActiveLists(newViewpoint.viewpointId)
            }
            
            NotificationEventBus.emitSuccessMessage()
            this.showCreateViewpointDialog = false;
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err)
        }
    
    }

    private async editAutocreateViewpoint(payload: Viewpoint) {
        await viewpointsModule.selectActiveViewpoint(payload.viewpointId);
        this.showCreateViewpointDialog = false;
    }


}

